/**
 * Normalizes an email by trimming whitespace, removing internal spaces, and lowercasing the domain.
 *
 * @param email - The email string to normalize
 * @returns Normalized email string
 */
export const normalizeEmail = (email: string): string => {
  const sanitizedEmail = email.replace(/\s+/g, '');
  const [localPart, domain] = sanitizedEmail.toLowerCase().trim().split('@');
  return localPart && domain ? `${localPart}@${domain}` : sanitizedEmail.trim();
};
